// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';
export const getDocTasks = createAction('documents/saga/get-tasks');
export const createDocTask = createAction('documents/saga/create-task');
export const createDocSectionTask = createAction('documents/saga/create-doc-section-task');
export const updateDocTask = createAction('documents/saga/update-task');
export const updateDocTaskIdNameMap = createAction('documents/saga/update-task-section-id-name-map');
